import {IAddressResponseData, IAddressData} from "../../../../../typescript-library";
import {BraintreeAddress} from "@paypal/react-paypal-js/dist/types/types/braintree/commonsTypes";

/* Just split address line dependent on countryCode:
 * -default: by space before the first word that contains decimals
 * -GB/FR: reverse order, split by space after word with first decimal appearance
 * -US: shift out first value as street number, the remains as street
 */
export function splitStreetAndNumber(line: string, countryCode: string): string[] {
  if (countryCode === "US") {
    const streetLine = line.split(" ");
    const usNumber = streetLine.shift() ?? "";
    const usStreet = streetLine.join(" ");

    return [usStreet, usNumber];
  }

  const swapStreetAndNum = ["GB", "FR"].includes(countryCode);

  const tempLine = swapStreetAndNum ? line.split("").reverse().join("") : line;

  const firstDecimalAppearance = tempLine.search(/\d/);
  const whitespaceAppearanceBeforeDecimal =
    firstDecimalAppearance - tempLine.substring(0, firstDecimalAppearance).split("").reverse().join("").search(/\s/);

  const tempStreet = tempLine.substring(0, whitespaceAppearanceBeforeDecimal - 1);
  const tempNo = tempLine.substring(whitespaceAppearanceBeforeDecimal);

  const street = swapStreetAndNum ? tempStreet.split("").reverse().join("") : tempStreet;
  const streetNo = swapStreetAndNum ? tempNo.split("").reverse().join("") : tempNo;

  return [street, streetNo];
}

/**
 * braintree address to internal address adapter function
 * Email separated, so there will be used just one
 * @param braintreeAddress
 * @param email
 */
export function prepareAddress(braintreeAddress: BraintreeAddress, email: string): Partial<IAddressData> {
  const {city, countryCode, line1, phone, postalCode, recipientName, state} = braintreeAddress;
  const recipientNameArray = recipientName?.split(" ") ?? ["", ""];
  const firstName = recipientNameArray.shift();
  const lastName = recipientNameArray.join(" ");
  const streetAndNum = splitStreetAndNumber(line1, countryCode);
  const street = streetAndNum[0];
  const streetNumber = streetAndNum[1];

  return {
    city,
    countryCode,
    email,
    firstName,
    gender: null,
    lastName,
    number: streetNumber,
    street,
    phone,
    zip: postalCode,
    state: state === "Empty" ? undefined : state,
  } as Partial<IAddressData>;
}

/**
 * Convert our addresses to braintree format
 * @param deliveryAddress
 */
export const convertAddress = (deliveryAddress: IAddressResponseData | undefined): BraintreeAddress | undefined => {
  let shippingAddressOverride: BraintreeAddress | undefined;
  if (deliveryAddress) {
    const {city, countryCode, firstName, lastName, state, street, zip} = deliveryAddress;
    const streetnumber = deliveryAddress.number;
    shippingAddressOverride = {
      city,
      countryCode,
      line1: ["GB", "FR", "US"].includes(countryCode) ? `${streetnumber} ${street}` : `${street} ${streetnumber}`,
      postalCode: zip,
      recipientName: `${firstName} ${lastName}`,
      state: state ?? "",
    };
  }

  return shippingAddressOverride;
};
